import axios from "axios";
import eventsOddsHandler from "@/services/eventsOddsHandlerV3";

// 🔴 COSTANTE CENTRALIZZATA PER LA PAGINAZIONE
const DEFAULT_PAGINATION_LIMIT = 20;

//stable version 3.0 fixed memory leak 16/04/2026


const state = {
    preview: [],
    previewFeatured: [],
    tournamentsActive: [],
    loadingPreviewIds: [],
    loading: false,
    loadingMore: false,
    pagination: {},
    configuredGroupsMarkets: [],
    marketsGroupsIdActive: [],
    marketsIdActive: [],
    previewTabsSelectedForTournament: []
};

const getters = {
    getPreview: (state) => state.preview,
    getFeaturedPreview: (state) => state.previewFeatured,
    getTournamentsActive: (state) => state.tournamentsActive,
    getLoadingPreview: (state) => state.loadingPreviewIds,
    isLoading: (state) => state.loading,
    isLoadingMore: (state) => state.loadingMore,
    getPaginationBySource: (state) => (source) => state.pagination[source] || null,
    getConfiguredGroupsMarkets: (state) => state.configuredGroupsMarkets,
    getMarketsGroupsIdActive: (state) => state.marketsGroupsIdActive,
    getMarketsIdActive: (state) => state.marketsIdActive,
    getPreviewTabsSelectedForTournament: (state) => state.previewTabsSelectedForTournament
};

const mutations = {
    SET_LOADING_GLOBAL(state, status) {
        state.loading = status;
    },
    SET_LOADING_MORE(state, status) {
        state.loadingMore = status;
    },
    SET_PAGINATION(state, { source, data }) {
        state.pagination = { ...state.pagination, [source]: data };
    },
    ADD_LOADING_PREVIEW_ID(state, id) {
        if (!state.loadingPreviewIds.includes(id)) state.loadingPreviewIds.push(id);
    },
    REMOVE_LOADING_PREVIEW_ID(state, id) {
        state.loadingPreviewIds = state.loadingPreviewIds.filter(itemId => itemId !== id);
    },
    SET_PREVIEW(state, payload) {
        state.preview = payload;
    },
    ADD_PREVIEW(state, payload) {
        state.preview.unshift(payload);
    },
    ADD_PREVIEW_REVERSE(state, payload) {
        state.preview.push(payload);
    },
    REPLACE_PREVIEW(state, payload) {
        if (!payload.tournament) return;

        // Dedup liveEvents in arrivo dall'API prima di salvare
        if (Array.isArray(payload.liveEvents)) {
            const seen = new Set();
            payload.liveEvents = payload.liveEvents.filter(e => {
                if (seen.has(e.id)) return false;
                seen.add(e.id);
                return true;
            });
        }

        const objIndex = state.preview.findIndex(
            preview => preview.tournament.id == payload.tournament.id
        );

        if (objIndex !== -1) {
            state.preview.splice(objIndex, 1, payload);
        } else {
            state.preview.unshift(payload);
        }
    },

    // 🔴 FIX: Normalizzazione ad Array sia degli eventi esistenti che di quelli in arrivo
    APPEND_PREVIEW(state, payload) {
        if (!payload.tournament) return;

        const objIndex = state.preview.findIndex(
            preview => preview.tournament.id == payload.tournament.id
        );

        if (objIndex !== -1) {
            const existingTournament = state.preview[objIndex];

            // 1. Convertiamo in Array gli eventi GIA' ESISTENTI (se sono un oggetto)
            let existingEventsArray = [];
            if (Array.isArray(existingTournament.events)) {
                existingEventsArray = existingTournament.events;
            } else if (existingTournament.events && typeof existingTournament.events === 'object') {
                existingEventsArray = Object.values(existingTournament.events);
            }

            // 2. Convertiamo in Array i NUOVI eventi in arrivo dall'API
            let incomingEvents = [];
            if (Array.isArray(payload.events)) {
                incomingEvents = payload.events;
            } else if (payload.events && typeof payload.events === 'object') {
                incomingEvents = Object.values(payload.events);
            }

            // 3. Facciamo il merge
            if (incomingEvents.length > 0) {
                incomingEvents.forEach(newDateGroup => {
                    // Ora possiamo usare liberamente .find() perché existingEventsArray è sicuramente un Array
                    const existingDateGroup = existingEventsArray.find(d => d.scheduled === newDateGroup.scheduled);

                    if (existingDateGroup) {
                        newDateGroup.events.forEach(newEv => {
                            const isDuplicate = existingDateGroup.events.some(e => e.id === newEv.id);
                            if (!isDuplicate) {
                                existingDateGroup.events.push(newEv);
                            }
                        });
                    } else {
                        existingEventsArray.push(newDateGroup);
                    }
                });

                // 4. Riordiniamo le date per sicurezza
                existingEventsArray.sort((a, b) => {
                    const timeA = a.scheduled ? new Date(a.scheduled).getTime() : Infinity;
                    const timeB = b.scheduled ? new Date(b.scheduled).getTime() : Infinity;
                    return timeA - timeB;
                });

                // 5. Riallochiamo l'array pulito all'oggetto tournament
                existingTournament.events = existingEventsArray;
            }

            // 6. Merge liveEvents con dedup (paginazione mixed: nuovi live nelle pagine successive)
            if (Array.isArray(payload.liveEvents) && payload.liveEvents.length > 0) {
                const existingLive = Array.isArray(existingTournament.liveEvents) ? existingTournament.liveEvents : [];
                const existingIds = new Set(existingLive.map(e => e.id));
                const newLive = payload.liveEvents.filter(e => !existingIds.has(e.id));
                existingTournament.liveEvents = [...existingLive, ...newLive];
            }

            // Trigger reattività di Vue
            state.preview.splice(objIndex, 1, existingTournament);
        } else {
            // Se l'oggetto è nuovo di zecca, normalizziamolo per le future paginazioni
            if (payload.events && !Array.isArray(payload.events) && typeof payload.events === 'object') {
                payload.events = Object.values(payload.events);
            }
            state.preview.push(payload);
        }
    },

    // ── Featured preview mutations ──────────────────────────────
    SET_FEATURED_PREVIEW(state, payload) {
        state.previewFeatured = payload;
    },
    ADD_FEATURED_PREVIEW(state, payload) {
        state.previewFeatured.unshift(payload);
    },
    ADD_FEATURED_PREVIEW_REVERSE(state, payload) {
        state.previewFeatured.push(payload);
    },
    REPLACE_FEATURED_PREVIEW(state, payload) {
        if (!payload.tournament) return;
        if (Array.isArray(payload.liveEvents)) {
            const seen = new Set();
            payload.liveEvents = payload.liveEvents.filter(e => {
                if (seen.has(e.id)) return false;
                seen.add(e.id);
                return true;
            });
        }
        const idx = state.previewFeatured.findIndex(p => p.tournament.id == payload.tournament.id);
        if (idx !== -1) {
            state.previewFeatured.splice(idx, 1, payload);
        } else {
            state.previewFeatured.unshift(payload);
        }
    },
    APPEND_FEATURED_PREVIEW(state, payload) {
        if (!payload.tournament) return;
        const idx = state.previewFeatured.findIndex(p => p.tournament.id == payload.tournament.id);
        if (idx !== -1) {
            const existing = state.previewFeatured[idx];
            let existingEventsArray = Array.isArray(existing.events)
                ? existing.events
                : (existing.events && typeof existing.events === 'object' ? Object.values(existing.events) : []);
            let incoming = Array.isArray(payload.events)
                ? payload.events
                : (payload.events && typeof payload.events === 'object' ? Object.values(payload.events) : []);
            if (incoming.length > 0) {
                incoming.forEach(newGroup => {
                    const existingGroup = existingEventsArray.find(d => d.scheduled === newGroup.scheduled);
                    if (existingGroup) {
                        newGroup.events.forEach(newEv => {
                            if (!existingGroup.events.some(e => e.id === newEv.id)) {
                                existingGroup.events.push(newEv);
                            }
                        });
                    } else {
                        existingEventsArray.push(newGroup);
                    }
                });
                existingEventsArray.sort((a, b) => {
                    const tA = a.scheduled ? new Date(a.scheduled).getTime() : Infinity;
                    const tB = b.scheduled ? new Date(b.scheduled).getTime() : Infinity;
                    return tA - tB;
                });
                existing.events = existingEventsArray;
            }
            if (Array.isArray(payload.liveEvents) && payload.liveEvents.length > 0) {
                const existingLive = Array.isArray(existing.liveEvents) ? existing.liveEvents : [];
                const existingIds = new Set(existingLive.map(e => e.id));
                existing.liveEvents = [...existingLive, ...payload.liveEvents.filter(e => !existingIds.has(e.id))];
            }
            state.previewFeatured.splice(idx, 1, existing);
        } else {
            if (payload.events && !Array.isArray(payload.events) && typeof payload.events === 'object') {
                payload.events = Object.values(payload.events);
            }
            state.previewFeatured.push(payload);
        }
    },

    ADD_TOURNAMENT_ACTIVE(state, source) {
        if (!state.tournamentsActive.includes(source)) state.tournamentsActive.push(source);
    },
    SET_TOURNAMENTS_ACTIVE(state, payload) {
        state.tournamentsActive = payload;
    },
    REMOVE_TOURNAMENT_ACTIVE(state, source) {
        state.tournamentsActive = state.tournamentsActive.filter(t => t !== source);
        const newPagination = { ...state.pagination };
        delete newPagination[source];
        state.pagination = newPagination;
    },
    addGroupsMarketsObject(state, payload) {
        state.configuredGroupsMarkets.push(payload);
    },
    setMarketsGroupsIdActive(state, payload) {
        state.marketsGroupsIdActive = payload;
    },
    addMarketsGroupIdActive(state, payload) {
        state.marketsGroupsIdActive.push(payload);
    },
    replaceMarketGroupIdActive(state, payload) {
        const objIndex = state.marketsGroupsIdActive.findIndex(
            info => info.tournamentId == payload.tournamentId
        );

        if (objIndex !== -1) {
            state.marketsGroupsIdActive.splice(objIndex, 1, payload);
        } else {
            state.marketsGroupsIdActive.push(payload);
        }
    },
    SET_PREVIEW_TYPE_VIEW(state, payload) {
        const marketIndex = state.marketsGroupsIdActive.findIndex(
            active => active.tournamentId == payload.tournamentId
        );

        if (marketIndex !== -1) {
            const newItem = {
                ...state.marketsGroupsIdActive[marketIndex],
                typeView: payload.typeView
            };
            state.marketsGroupsIdActive.splice(marketIndex, 1, newItem);
        }
    },
    SET_SIZE_ODD_BUTTON(state, payload) {
        const marketIndex = state.marketsGroupsIdActive.findIndex(
            active => active.tournamentId == payload.tournamentId
        );

        if (marketIndex !== -1) {
            const newItem = {
                ...state.marketsGroupsIdActive[marketIndex],
                sizeOddsButtons: payload.sizeOddsButtons
            };
            state.marketsGroupsIdActive.splice(marketIndex, 1, newItem);
        }
    },
    FIND_AND_UPDATE_PREVIEW_TABS_ACTIVE_FOR_TOURNAMENT(state, payload) {
        const index = state.previewTabsSelectedForTournament.findIndex(
            tab => tab.tournamentId == payload.tournamentId
        );

        if (index === -1) {
            state.previewTabsSelectedForTournament.push(payload);
        } else {
            state.previewTabsSelectedForTournament.splice(index, 1, payload);
        }
    },
    REMOVE_MARKETS_GROUP_ID_ACTIVE(state, tournamentId) {
        state.marketsGroupsIdActive = state.marketsGroupsIdActive.filter(
            mg => mg.tournamentId != tournamentId
        );
    },
    REMOVE_PREVIEW_TABS_FOR_TOURNAMENT(state, tournamentId) {
        state.previewTabsSelectedForTournament = state.previewTabsSelectedForTournament.filter(
            tab => tab.tournamentId != tournamentId
        );
    },
    REMOVE_CONFIGURED_GROUPS_MARKETS(state, tournamentId) {
        state.configuredGroupsMarkets = state.configuredGroupsMarkets.filter(
            gm => gm.tournamentId != tournamentId
        );
    }
};

const actions = {
    async fetchPreview({ dispatch }, payload) {
        if (!payload.skipHistory) {
            await dispatch('sportNavigation/pushHistory', null, { root: true });
        }
        await dispatch('fetchPreviewV3', payload);
    },

    async fetchMixedPreview({ state, commit, dispatch, rootGetters }, payload) {
        const page  = payload.page  || 1;
        const limit = payload.limit
            || rootGetters['settings/getPrematchPreviewMaxEvents']
            || DEFAULT_PAGINATION_LIMIT;

        const source = String(payload.tournamentId) + '#prematch';

        if (page === 1 && state.tournamentsActive.includes(source)) {
            commit('REMOVE_TOURNAMENT_ACTIVE', source);
        }

        if (page === 1) {
            commit('ADD_TOURNAMENT_ACTIVE', source);
            commit('SET_LOADING_GLOBAL', true);
        } else {
            commit('SET_LOADING_MORE', true);
        }

        const apiUrl      = rootGetters['settings/getUrlApi'];
        const token       = rootGetters['settings/getToken'];
        const platformId  = rootGetters['settings/getPlatformId'];
        const language    = rootGetters['settings/getLanguage'];
        const axiosConfig = { headers: { Authorization: `Bearer ${token}` } };

        const requestPayload = {
            platformId,
            tournamentId: payload.tournamentId,
            sportId:      payload.sportId,
            categoryId:   payload.categoryId ?? null,
            lang:         language,
            groupId:      payload.groupId  ?? null,
            marketId:     payload.marketId ?? null,
            mobilePlatform:  false,
            filterEmptyOdds: false,
            page,
            limit
        };

        try {
            const res = await axios.post(`${apiUrl}/v3/events/tournament/mixed-preview`, requestPayload, axiosConfig);

            const result       = res.data?.result ?? {};
            const allEvents    = (result?.groupedEvents ?? []).flat();
            const hasValidEvents = res.data.messages === 'Success Operation' && allEvents.length > 0;

            if (res.data.pagination) {
                commit('SET_PAGINATION', { source, data: res.data.pagination });
            }

            if (hasValidEvents) {
                const sportObj      = { id: payload.sportId,      name: res.data.sportName      ?? payload.sportName      ?? '' };
                const categoryObj   = { id: payload.categoryId,   name: res.data.categoryName   ?? payload.categoryName   ?? '' };
                const tournamentObj = { id: payload.tournamentId, name: res.data.tournamentName ?? payload.tournamentName ?? '' };

                // Separate live vs prematch
                const liveEventsFlat    = allEvents.filter(e => e._matchType === 'live' || e.matchType === 'live' || e.matchType === 'starting_soon');
                const prematchEvents    = allEvents.filter(e => e._matchType !== 'live' && e.matchType !== 'live');

                // Group prematch by date
                const dateMap = new Map();
                for (const ev of [...prematchEvents].sort((a, b) => new Date(a.scheduled) - new Date(b.scheduled))) {
                    const dateKey = ev.scheduled ? new Date(ev.scheduled).toLocaleDateString('en-CA') : 'unknown';
                    if (!dateMap.has(dateKey)) dateMap.set(dateKey, { scheduled: dateKey, events: [] });
                    dateMap.get(dateKey).events.push(ev);
                }
                const eventsObj = {};
                for (const [key, group] of [...dateMap.entries()].sort(([a], [b]) => a.localeCompare(b))) {
                    eventsObj[key] = group;
                }

                const headerSignLive     = result.headerSign          ?? null;
                const headerSignPrematch = result.headerSignPrematch   ?? null;

                const data_events = {
                    sport:             sportObj,
                    category:          categoryObj,
                    tournament:        tournamentObj,
                    events:            eventsObj,
                    liveEvents:        liveEventsFlat,
                    source,
                    type:              'prematch',
                    headerSign:        headerSignPrematch,
                    headerSignLive,
                    isMixed:           true,
                };

                if (page === 1) {
                    commit('REPLACE_PREVIEW', data_events);
                    window.parent.postMessage({
                        type:           'tournamentOpened',
                        sportId:        payload.sportId,
                        tournamentId:   payload.tournamentId,
                        sportName:      sportObj.name,
                        tournamentName: tournamentObj.name
                    }, '*');
                } else {
                    commit('APPEND_PREVIEW', data_events);
                }

            } else {
                if (page === 1) {
                    dispatch('odds/showAlertEventNotAvailable', source, { root: true });
                    commit('REMOVE_TOURNAMENT_ACTIVE', source);
                }
            }

        } catch (error) {
            console.error('[previewPrematch] fetchMixedPreview error:', error);
            if (page === 1) {
                dispatch('odds/showAlertEventNotAvailable', source, { root: true });
                commit('REMOVE_TOURNAMENT_ACTIVE', source);
            }
        } finally {
            if (page === 1) commit('SET_LOADING_GLOBAL', false);
            commit('SET_LOADING_MORE', false);
        }
    },


    async fetchPreviewV3({ state, commit, dispatch, rootGetters }, payload) {
        const isMobile = payload.mobilePlatform ?? false;
        const forceCallApi = payload.forceCallApi ?? false;

        const page = payload.page || 1;
        const limit = payload.limit
            || rootGetters['settings/getPrematchPreviewMaxEvents']
            || DEFAULT_PAGINATION_LIMIT;

        if (page === 1 && state.tournamentsActive.includes(payload.source) && !forceCallApi) {
            return;
        }

        if (isMobile && page === 1) {
            commit('SET_PREVIEW', []);
            commit('SET_TOURNAMENTS_ACTIVE', []);
            commit('setMarketsGroupsIdActive', []);
        }

        if (page === 1) {
            commit('ADD_TOURNAMENT_ACTIVE', payload.source);
            commit('SET_LOADING_GLOBAL', true);
        } else {
            commit('SET_LOADING_MORE', true);
        }

        const requestPayload = {
            platformId: rootGetters['settings/getPlatformId'],
            sportId: payload.sportId,
            categoryId: payload.categoryId,
            tournamentId: payload.tournament,
            type: payload.type,
            section: "sport",
            filter: rootGetters['treeV2/getFilter'],
            lang: rootGetters['settings/getLanguage'],
            forceDefaultGameConsole: payload.forceDefaultGameConsole || null,
            mobilePlatform: isMobile,
            groupOddsWithSpreads: payload.groupOddsWithSpreads || false,
            groupId: payload.groupId,
            marketId: payload.marketId ?? null,
            filterEmptyOdds: true,
            page: page,
            limit: limit,
            categoryName: payload.categoryName || undefined,
            tournamentName: payload.tournamentName || undefined
        };

        const apiUrl = rootGetters['settings/getUrlApi'];
        const axiosConfig = { headers: { Authorization: `Bearer ${rootGetters['settings/getToken']}` } };

        try {
            const res = await axios.post(`${apiUrl}/v3/events/prematch/tournament/preview`, requestPayload, axiosConfig);

            const hasValidEvents = res.data.messages === "Success Operation" && res.data.events && Object.keys(res.data.events).length > 0;

            if (res.data.pagination) {
                commit('SET_PAGINATION', { source: payload.source, data: res.data.pagination });
            }

            if (hasValidEvents) {
                const sportObj = { id: payload.sportId, name: res.data.sportName };
                const categoryObj = { id: payload.categoryId, name: res.data.categoryName };
                const tournamentObj = { id: payload.tournament, name: res.data.tournamentName };
                const onlyManager = rootGetters['settings/getPlatformId'] == 0;
                const producer = 0;

                const data_events = await eventsOddsHandler.refactorPreviewV2(
                    res.data, sportObj, categoryObj, tournamentObj, producer, onlyManager, payload.source
                );

                if (page === 1) {
                    if (isMobile || payload.mode === 'substitute') {
                        commit('REPLACE_PREVIEW', data_events);
                    } else if (payload.mode === 'reverse') {
                        commit('ADD_PREVIEW_REVERSE', data_events);
                    } else {
                        commit('ADD_PREVIEW', data_events);
                    }

                    window.parent.postMessage({
                        type: 'tournamentOpened',
                        sportId: payload.sportId,
                        tournamentId: payload.tournament,
                        sportName: res.data.sportName ?? payload.sportName ?? 'sport',
                        tournamentName: res.data.tournamentName ?? payload.tournamentName ?? 'tournament'
                    }, "*");
                } else {
                    commit('APPEND_PREVIEW', data_events);
                }

            } else {
                if (page === 1) {
                    dispatch('odds/showAlertEventNotAvailable', payload.source, { root: true });
                    commit('REMOVE_TOURNAMENT_ACTIVE', payload.source);
                }
            }

        } catch (error) {
            console.error("Error fetchPreviewV3:", error);
            if (page === 1) {
                dispatch('odds/showAlertEventNotAvailable', payload.source, { root: true });
                commit('REMOVE_TOURNAMENT_ACTIVE', payload.source);
            }
        } finally {
            if (page === 1) commit('SET_LOADING_GLOBAL', false);
            commit('SET_LOADING_MORE', false);
        }
    },

    async fetchFeaturedPreviewV3({ state, commit, dispatch, rootGetters }, payload) {
        const isMobile = payload.mobilePlatform ?? false;
        const forceCallApi = payload.forceCallApi ?? false;

        const page = payload.page || 1;
        const limit = payload.limit
            || rootGetters['settings/getPrematchPreviewMaxEvents']
            || DEFAULT_PAGINATION_LIMIT;

        if (page === 1 && state.tournamentsActive.includes(payload.source) && !forceCallApi) {
            return;
        }

        if (page === 1) {
            commit('ADD_TOURNAMENT_ACTIVE', payload.source);
            commit('SET_LOADING_GLOBAL', true);
        } else {
            commit('SET_LOADING_MORE', true);
        }

        const requestPayload = {
            platformId: rootGetters['settings/getPlatformId'],
            sportId: payload.sportId,
            categoryId: payload.categoryId,
            tournamentId: payload.tournament,
            type: payload.type,
            section: 'sport',
            filter: rootGetters['treeV2/getFilter'],
            lang: rootGetters['settings/getLanguage'],
            forceDefaultGameConsole: payload.forceDefaultGameConsole || null,
            mobilePlatform: isMobile,
            groupOddsWithSpreads: payload.groupOddsWithSpreads || false,
            groupId: payload.groupId,
            marketId: payload.marketId ?? null,
            filterEmptyOdds: true,
            page,
            limit,
            categoryName: payload.categoryName || undefined,
            tournamentName: payload.tournamentName || undefined,
        };

        const apiUrl = rootGetters['settings/getUrlApi'];
        const axiosConfig = { headers: { Authorization: `Bearer ${rootGetters['settings/getToken']}` } };

        try {
            const res = await axios.post(`${apiUrl}/v3/events/prematch/tournament/preview`, requestPayload, axiosConfig);

            const hasValidEvents = res.data.messages === 'Success Operation' && res.data.events && Object.keys(res.data.events).length > 0;

            if (res.data.pagination) {
                commit('SET_PAGINATION', { source: payload.source, data: res.data.pagination });
            }

            if (hasValidEvents) {
                const sportObj = { id: payload.sportId, name: res.data.sportName };
                const categoryObj = { id: payload.categoryId, name: res.data.categoryName };
                const tournamentObj = { id: payload.tournament, name: res.data.tournamentName };
                const onlyManager = rootGetters['settings/getPlatformId'] == 0;

                const data_events = await eventsOddsHandler.refactorPreviewV2(
                    res.data, sportObj, categoryObj, tournamentObj, 0, onlyManager, payload.source
                );

                if (page === 1) {
                    if (payload.mode === 'substitute') {
                        commit('REPLACE_FEATURED_PREVIEW', data_events);
                    } else if (payload.mode === 'reverse') {
                        commit('ADD_FEATURED_PREVIEW_REVERSE', data_events);
                    } else {
                        commit('ADD_FEATURED_PREVIEW', data_events);
                    }
                } else {
                    commit('APPEND_FEATURED_PREVIEW', data_events);
                }
            } else {
                if (page === 1) {
                    commit('REMOVE_TOURNAMENT_ACTIVE', payload.source);
                }
            }
        } catch (error) {
            console.error('[previewPrematch] fetchFeaturedPreviewV3 error:', error);
            if (page === 1) commit('REMOVE_TOURNAMENT_ACTIVE', payload.source);
        } finally {
            if (page === 1) commit('SET_LOADING_GLOBAL', false);
            commit('SET_LOADING_MORE', false);
        }
    },

    async fetchPreviewForMarketV3({ commit, dispatch, rootGetters }, payload) {
        const page = payload.page || 1;
        const limit = payload.limit ||  rootGetters['settings/getPrematchPreviewMaxEvents'] ||  DEFAULT_PAGINATION_LIMIT;

        if (page === 1) {
            commit('ADD_LOADING_PREVIEW_ID', payload.tournament.id);
        } else {
            commit('SET_LOADING_MORE', true);
        }

        const requestPayload = {
            platformId: rootGetters['settings/getPlatformId'],
            sportId: payload.sport.id,
            categoryId: payload.category.id,
            tournamentId: payload.tournament.id,
            marketId: payload.market,
            groupId: payload.groupId,
            type: payload.type,
            section: "sport",
            filter: rootGetters['treeV2/getFilter'],
            lang: rootGetters['settings/getLanguage'],
            mobilePlatform: payload.mobilePlatform || false,
            groupOddsWithSpreads: payload.groupOddsWithSpreads || false,
            filterEmptyOdds: true,
            page: page,
            limit: limit,
            categoryName: payload.category.name || undefined,
            tournamentName: payload.tournament.name || undefined,
        };

        const apiUrl = rootGetters['settings/getUrlApi'];
        const axiosConfig = { headers: { Authorization: `Bearer ${rootGetters['settings/getToken']}` } };

        try {
            const res = await axios.post(`${apiUrl}/v3/events/prematch/tournament/preview`, requestPayload, axiosConfig);

            const hasValidEvents = res.data.messages === "Success Operation" && res.data.events && Object.keys(res.data.events).length > 0;

            if (res.data.pagination) {
                commit('SET_PAGINATION', { source: payload.source, data: res.data.pagination });
            }

            if (hasValidEvents) {
                const onlyManager = rootGetters['settings/getPlatformId'] == 0;
                const producer = 0;
                const sportObj = { id: payload.sport.id, name: res.data.sportName };
                const categoryObj = { id: payload.category.id, name: res.data.categoryName };
                const tournamentObj = { id: payload.tournament.id, name: res.data.tournamentName };

                const data_events = await eventsOddsHandler.refactorPreviewV2(
                    res.data, sportObj, categoryObj, tournamentObj, producer, onlyManager, payload.source
                );

                if (page === 1) {
                    commit('REPLACE_PREVIEW', data_events);

                    if (res.data.typeView) {
                        commit('SET_PREVIEW_TYPE_VIEW', { tournamentId: payload.tournament.id, typeView: res.data.typeView });
                    }
                    if (res.data.sizeOddsButtons) {
                        commit('SET_SIZE_ODD_BUTTON', { tournamentId: payload.tournament.id, sizeOddsButtons: res.data.sizeOddsButtons });
                    }
                } else {
                    commit('APPEND_PREVIEW', data_events);
                }

            } else {
                if (page === 1) {
                    const empty_data = {
                        sport: payload.sport,
                        category: payload.category,
                        tournament: payload.tournament,
                        events: {},
                        headerSign: [],
                        source: payload.source,
                        type: payload.type,
                        is_outright: false,
                        producer_id: 0
                    };
                    commit('REPLACE_PREVIEW', empty_data);
                }
            }

        } catch (error) {
            console.error("Error fetchPreviewForMarketV3:", error);
            if (page === 1) dispatch('odds/showAlertEventNotAvailable', payload.source, { root: true });
        } finally {
            if (page === 1) commit('REMOVE_LOADING_PREVIEW_ID', payload.tournament.id);
            commit('SET_LOADING_MORE', false);
        }
    },

    async fetchSettingsGroupsMarketV3({ state, commit, rootGetters }, payload) {
        if (!payload.sport) return;

        const groupMarketExists = state.configuredGroupsMarkets.some(setting =>
            setting.sport_id === payload.sport &&
            setting.sportId === payload.sportId &&
            setting.categoryId === payload.categoryId &&
            setting.tournamentId === payload.tournamentId
        );

        if (groupMarketExists) return;

        try {
            const apiUrl = rootGetters['settings/getUrlApi'];
            const axiosConfig = { headers: { Authorization: `Bearer ${rootGetters['settings/getToken']}` } };

            const requestPayload = {
                section: "sport",
                lang: payload.lang,
                product_id: payload.product_id,
                platform: payload.platform,
                type: payload.type,
                sportId: payload.sportId,
                tournamentId: payload.tournamentId,
                categoryId: payload.categoryId
            };

            const res = await axios.post(`${apiUrl}/v3/market-groups/markets-available-by-tournament`, requestPayload, axiosConfig);

            let data_to_save = [];
            if (res.data) {
                data_to_save = res.data;
            }

            commit('addGroupsMarketsObject', {
                sport_id: payload.sport,
                sportId: payload.sportId,
                categoryId: payload.categoryId,
                tournamentId: payload.tournamentId,
                data: data_to_save
            });

        } catch (error) {
            console.error('[ERROR] Failed to get configured groups markets', error);
        }
    },

    async addOrUpdateIndexOfTabActiveForThisTournament({ commit }, payload) {
        commit('FIND_AND_UPDATE_PREVIEW_TABS_ACTIVE_FOR_TOURNAMENT', payload);
    },

    async removeFromPreview({ state, commit }, payload) {
        const tournamentToRemove = state.preview.find(t => t.source === payload.source);
        const updatedPreview = state.preview.filter(t => t.source !== payload.source);
        commit('SET_PREVIEW', updatedPreview);
        commit('REMOVE_TOURNAMENT_ACTIVE', payload.source);
        if (tournamentToRemove && tournamentToRemove.tournament) {
            const tid = tournamentToRemove.tournament.id;
            commit('REMOVE_MARKETS_GROUP_ID_ACTIVE', tid);
            commit('REMOVE_PREVIEW_TABS_FOR_TOURNAMENT', tid);
            commit('REMOVE_CONFIGURED_GROUPS_MARKETS', tid);
        }
        window.parent.postMessage({ type: 'removeSlugs' }, '*');
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};